import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { useMobileDetect } from "@hooks/useMobileDetect";
import { Selectors } from "./Selectors";
import { Footer } from "../Footer";
import styles from "./styles/MobileForm.module.css";
import { useForm } from "../hooks/useForm";
import { isBra } from "../../lib/isBra";
import { getSize } from "../../lib/product-utils";
import { SizeGuide } from "../../";
import { resolveHasSizeData } from "../../SizeGuide/lib/resolve-has-data";

export function MobileForm({
  section,
  sections,
  index,
  handleScrollTo,
  isStockup,
  discountMessage,
  slug,
}) {
  const [showSizeGuide, setShowSizeGuide] = useState(false);
  const [targetElement, setTargetElement] = useState(null);
  const sizeGuideRef = useRef(null);
  const currentDevice = useMobileDetect();
  const {
    totalPrice,
    totalCompareAtPrice,
    product,
    navigation,
    options,
    handleOptionChange,
    handleNavigationChange,
    handleSubmit,
  } = useForm(sections, section, discountMessage, slug);
  const { state } = useStateMachine();

  useEffect(() => {
    setTargetElement(sizeGuideRef.current);
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);

  function closeSizeGuide() {
    setShowSizeGuide(false);
    if (currentDevice.isMobile()) {
      enableBodyScroll(targetElement);
    }
  }

  function openSizeGuide() {
    setShowSizeGuide(true);
    if (currentDevice.isMobile()) {
      disableBodyScroll(targetElement);
    }
  }

  return (
    <>
      {state[`${section.key}-productGroup`].sizeGuide && (
        <SizeGuide
          variant={state[`${section.key}-variant`]}
          data={state[`${section.key}-productGroup`].sizeGuide}
          isBra={isBra(state[`${section.key}-productGroup`].slug)}
          showSizeGuide={showSizeGuide}
          closeSizeGuide={closeSizeGuide}
          selectedSize={getSize(state[`${section.key}-variant`])}
          sizes={options.get("Size")}
          handleOptionChange={handleOptionChange}
          showFooter={false}
          ref={sizeGuideRef}
        />
      )}
      <form onSubmit={handleSubmit} className={styles.container}>
        <Selectors
          navigation={navigation}
          product={product}
          options={options}
          handleNavigationChange={handleNavigationChange}
          handleOptionChange={handleOptionChange}
          openSizeGuide={
            resolveHasSizeData(state[`${section.key}-productGroup`].sizeGuide)
              ? openSizeGuide
              : null
          }
        />
        <Footer
          index={index}
          sections={sections}
          handleScrollTo={handleScrollTo}
          isStockup={isStockup}
          discountMessage={discountMessage}
          totalPrice={totalPrice}
          totalCompareAtPrice={totalCompareAtPrice}
          handleSubmit={handleSubmit}
        />
      </form>
    </>
  );
}

MobileForm.propTypes = {};
